var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoadingPage)?_c('div',[_c('div',{staticClass:"text-div"},[_c('v-row',{staticClass:"fill-height",attrs:{"align":"center","justify":"center"}},[_c('p',{staticClass:"loader-text"},[_vm._v(" "+_vm._s(_vm.loadingMessage)+" ")])])],1),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-1"},[_c('i'),_c('i'),_c('i'),_c('i'),_c('i')])
}]

export { render, staticRenderFns }